import { useContext, useEffect, useState } from "react";
import { StyleContext } from "../../providers/StyleContextProvider";
import { Button } from "../Shared/Buttons/Button";
import { ReactComponent as Calender } from '../../assets/svg/calendar.svg';
import { getApplicationNote, saveApplicationNote } from "../../services/RecruiterService";
import { AuthContext } from "../../providers/AuthContextProvider";
import { LoggedRecruiter } from "../../models/LoggedRecruiter";
import useErrorPage from "../../hooks/useErrorPage";
import { ResponseModel } from "../../models/ResponseModel";

interface Props {
    jobApplicationId?: number;
    preApplicationId?: number;
    isCvLess: boolean;
}

interface Note {
    author: string;
    note: string;
}

export const NotesTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("applicationStatusTabs");  
    const styles = tabStyles.notesTab;    
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();    
    const [appNotes, setAppNotes] = useState<Note[]>();
    const [previousAppNotes, setPreviousAppNotes] = useState<string>("");
    const [notes, setNotes] = useState<string>('');
    const [toErrorPage] = useErrorPage();

    useEffect(() => {
        let applicationId;
        if (props.isCvLess) {
            applicationId = props.preApplicationId;
        }
        else {
            applicationId = props.jobApplicationId;
        }
        fetchApplicationNote(applicationId!);
    }, []);

    const parseNotes = (notesHtml: string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(notesHtml, 'text/html');
        const liElements = doc.querySelectorAll('li');
        const results = Array.from(liElements).map(li => {
            const authorSpan = li.querySelector('span.note-author');
            const authorText = authorSpan?.textContent?.trim() || '';
            const noteText = li.textContent?.replace(authorSpan?.textContent || '', '').replace(/^[:\-\s]+/, '').trim() || '';
            return {
                author: authorText,
                note: noteText
            };
        });
        return results;
    };

    const handleAddNote = () => {
        const trimmedNote = notes.trim();
        if (trimmedNote === "") {
            return;
        }
        const now = new Date();
        const dateString = now.toDateString();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const timeString = `${hours}:${minutes}`;
        const noteText = `<li><i><span class='note-author'> ${recruiter?.forename} on ${dateString} at ${timeString}</span></i> :- ${notes}</li>`;
        let applicationId;
        if (props.isCvLess) {
            applicationId = props.preApplicationId;
        }
        else {
            applicationId = props.jobApplicationId;
        }
        const noteHtml = previousAppNotes + noteText;
        saveAppNote(applicationId!, noteHtml);
    };

    const formatNoteText = (text: string) => {
        return text.replace(/\n/g, '<br />');
    };

    async function fetchApplicationNote(applicationId: number) {
        await getApplicationNote(applicationId, props.isCvLess, recruiter!.recruiterId, recruiter!.token)
        .then((response: string) => {
            setPreviousAppNotes(response);
            var data = parseNotes(response);
            setAppNotes(data);
        })
        .catch((error) => {            
            toErrorPage(error);
        });
    }

    async function saveAppNote(applicationId: number, notes: string) {
        await saveApplicationNote(applicationId, notes, props.isCvLess, recruiter!.recruiterId, recruiter!.token,)
        .then((response: ResponseModel) => {
            if (response.status){
                setNotes("");
                fetchApplicationNote(applicationId);
            }
        })
        .catch((error) => {            
            toErrorPage(error);
        });
    }

    return (
        <>
            <div style={styles.rowWrapper}>
                <div style={styles.title}>Notes</div>
            </div>
            <div style={styles.noteSection}>
                <div style={styles.noteWrapper}>
                    <div style={styles.noteWrapper.text}>{"New Note"}</div>
                    <textarea
                        name={"notes"}
                        value={notes} 
                        onChange={(e) => setNotes(e.target.value)} 
                        style={styles.noteWrapper.input}
                        className="scrollArea"
                    />
                    <div style={styles.noteWrapper.buttons}>
                        <Button style={styles.noteWrapper.addNoteButton} onClick={handleAddNote}>{"ADD NOTE"}</Button>
                        <Button style={styles.noteWrapper.discardButton} onClick={() => setNotes("")}>{"DISCARD"}</Button>
                    </div>
                </div>
                {appNotes?.map((appNote) => (
                    <div style={styles.previousNote}>
                        <div style={styles.previousNote.recordInfo}>
                            <Calender style={styles.previousNote.calendarIcon}/>
                            <div style={styles.previousNote.details}>
                                <div style={styles.previousNote.addedDate}>{appNote.author}</div>
                            </div>
                        </div>  
                        <div 
                            style={styles.previousNote.note}
                            dangerouslySetInnerHTML={{ __html: formatNoteText(appNote.note)}}
                        />
                    </div>
                ))}
            </div>
        </>
    );
}